var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleCheckboxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.77778 0C1.69137 0 0 1.69137 0 3.77778V13.2222C0 15.3086 1.69137 17 3.77778 17H13.2222C15.3086 17 17 15.3086 17 13.2222V3.77778C17 1.69137 15.3086 0 13.2222 0H3.77778ZM13.0302 6.53033C13.3231 6.23744 13.3231 5.76256 13.0302 5.46967C12.7373 5.17678 12.2624 5.17678 11.9695 5.46967L6.99988 10.4393L5.03021 8.46967C4.73731 8.17678 4.26244 8.17678 3.96955 8.46967C3.67665 8.76256 3.67665 9.23744 3.96955 9.53033L6.46955 12.0303C6.76244 12.3232 7.23731 12.3232 7.53021 12.0303L13.0302 6.53033Z",
    fill: "#8134FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCheckboxIcon);
export default __webpack_public_path__ + "static/media/purple-checkbox-icon.295bb23ff159d41ff2320f9a135446fc.svg";
export { ForwardRef as ReactComponent };